import { EUserRole } from "types/api/role";

/**
 * Utility function to check if the given role matches the expected role.
 * @param role - The current user role to be validated.
 * @param expectedRole - The role to check against.
 * @returns True if the role matches the expected role, otherwise false.
 */
const hasRole = (role?: EUserRole, expectedRole?: EUserRole): boolean => {
  return role === expectedRole;
};

/**
 * Check if the role is Admin.
 * @param role - The user role to evaluate.
 * @returns True if the role is Admin, otherwise false.
 */
export const isAdmin = (role?: EUserRole): boolean =>
  hasRole(role, EUserRole.ADMIN);

/**
 * Check if the role is Teacher.
 * @param role - The user role to evaluate.
 * @returns True if the role is Teacher, otherwise false.
 */
export const isTeacher = (role?: EUserRole): boolean =>
  hasRole(role, EUserRole.TEACHER);

/**
 * Check if the role is Student.
 * @param role - The user role to evaluate.
 * @returns True if the role is Student, otherwise false.
 */
export const isStudent = (role?: EUserRole): boolean =>
  hasRole(role, EUserRole.STUDENT);
